import React from 'react';
import { Route } from 'react-router';
import ProductRecommendation from 'split-chunk-loader?lazy!../ProductRecommendation';
import { lazify } from '../Common/Helper';

const ProductRecommendationRoute = (
    <Route label="Product Recommendation" path="recommendations" component={lazify(ProductRecommendation)} />
);

export default ProductRecommendationRoute;


// WEBPACK FOOTER //
// ./src/Routes/ProductRecommendation.js